import { render } from "./LiderStart.vue?vue&type=template&id=6807cbd3"
import script from "./LiderStart.vue?vue&type=script&lang=js"
export * from "./LiderStart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__